<label class="add-picture-button">
  <input type="file" (change)="onImagesSelected($event)" accept="image/png, image/jpeg" multiple />
</label>
